export const PAD_THEME_FOUNDATION = {
  fontSize: {
    sm: 14,
    base: 14,
    lg: 18,
    xl: 20,
  },
  lineHeight: 1.5,
  radii: {
    sm: 4,
    md: 6,
    lg: 12,
    xl: 16,
    full: 9999,
  },
  shadow: {
    small: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    medium: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)",
    large: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)",
  },
} as const;

export type PadThemeFoundation = typeof PAD_THEME_FOUNDATION;
